import { Outlet } from "react-router-dom";
import "../styles/App.css";
import { useAuth } from "../core/hooks/useAuth";

import { useMediaQuery } from "react-responsive";
import CopywriteFooter from "../components/CopywriteFooter";
import FixedPopup from "../components/PopPup";

const App = () => {
  const { isAuth } = useAuth();
  const isMobile = useMediaQuery({
    query: `(max-width: 768px)`,
  });
  return (
    <section id="app" className="App">
      <main className="main">
        <Outlet context={{ isMobile }} />
        <CopywriteFooter />
        <FixedPopup />
      </main>
    </section>
  );
};

export { App };
